import React from "react";
import { PartnerDetailPageContent, PartnerDetailPageStateProvider } from ".";

export const PartnerDetailPage = () => {
  return (
    <>
      <PartnerDetailPageStateProvider>
        <PartnerDetailPageContent></PartnerDetailPageContent>
      </PartnerDetailPageStateProvider>
    </>
  );
};
